import { BehaviorSubject } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
export class FineService extends BaseProvider {
    constructor(globals, http) {
        super();
        this.globals = globals;
        this.http = http;
        this.finesSubject = new BehaviorSubject([]);
        this.currentFines = this.finesSubject.asObservable();
        this.fineSubject = new BehaviorSubject(null);
        this.currentFine = this.finesSubject.asObservable();
        this.itemToEdit = { Id: '' };
        this.infractionCategory = [];
        this.infractionParentCategory = [];
        this.fineIsLoading = false;
        this.baseUrl = 'fine';
    }
    searchFines(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/term/' + params.term +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize +
                '/inspection/' + params.inspectionId +
                '/active/' + params.active +
                '/direction/' + params.direction;
            this.http
                .get(this.url)
                .subscribe((data) => {
                console.log('searchFines', data.Data);
                data.Data.forEach(item => {
                    if (item.ExternalInfractionIds) {
                        item.ExternalInfractionIdsArray = item.ExternalInfractionIds.split(',').map(id => id.trim());
                    }
                });
                this.finesSubject.next(data.Data);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    searchPofileFines(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/term/' + params.term +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize +
                '/active/' + params.active +
                '/direction/' + params.direction;
            this.http
                .get(this.url)
                .subscribe((data) => {
                console.log('searchFines', data.Data);
                data.Data.forEach(item => {
                    if (item.ExternalInfractionIds) {
                        item.ExternalInfractionIdsArray = item.ExternalInfractionIds.split(',').map(id => id.trim());
                    }
                });
                this.finesSubject.next(data.Data);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    searchFinesByProfile(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/term/null' +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize +
                '/profile/' + params.profileId +
                '/active/' + params.active +
                '/direction/' + params.direction;
            this.http
                .get(this.url)
                .subscribe((data) => {
                console.log('searchFines', data.Data);
                data.Data.forEach(item => {
                    if (item.ExternalInfractionIds) {
                        item.ExternalInfractionIdsArray = item.ExternalInfractionIds.split(',').map(id => id.trim());
                    }
                });
                this.finesSubject.next(data.Data);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getById(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + id;
            this.http.get(this.url).subscribe((data) => {
                this.setFineDetail(data.Data.fine);
                resolve(data.Data.infractions);
            }, (err) => {
                reject(err);
            });
        });
    }
    setFineDetail(fine) {
        this.itemToEdit = fine;
        this.fineSubject.next(fine);
    }
    getInfractionCategory(term) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/infractionCategory/term/' + term;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.infractionCategory = data.Data;
                console.log('this.infractionCategory', this.infractionCategory);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getInfractionParentCategory() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/infractionParentCategory/';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.infractionParentCategory = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    create(params) {
        console.log('params', params);
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    update(id, params) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/${id}`;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
FineService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FineService_Factory() { return new FineService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient)); }, token: FineService, providedIn: "root" });
